import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { InvoiceDoc } from '../_models/invoiceDoc';

@Injectable()
export class InvoiceDocService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getInvoiceDocs(): Observable<InvoiceDoc[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/documentInvoiceDocs')
      .pipe(map((response) => response));
  }

  getInvoiceDoc(id: number): Observable<InvoiceDoc> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/documentInvoiceDocs/' + id)
      .pipe(map((response) => response));
  }

  saveInvoiceDoc(invoiceDocItem: InvoiceDoc): Observable<InvoiceDoc> {
    const invoiceDoc = { ...invoiceDocItem };
    delete invoiceDoc.lastUpdated;
    delete invoiceDoc.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    invoiceDoc.companyId = companySelected ? companySelected.id : null;

    if (invoiceDoc.id) {
      return this.http
        .put<InvoiceDoc>(
          this.apiBaseUrl + 'api/private/v1/documentInvoiceDocs/' + invoiceDoc.id,
          invoiceDoc
        )
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<InvoiceDoc>(this.apiBaseUrl + 'api/private/v1/documentInvoiceDocs/', invoiceDoc)
        .pipe(map((response) => response));
    }
  }

  deleteInvoiceDoc(id: number): Observable<InvoiceDoc> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/documentInvoiceDocs/' + id).pipe(
      map((response) => {
        return { id } as InvoiceDoc;
      })
    );
  }
}
